import { ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { ApiService } from '../../core/api.service';
import { ActionType } from '../event-centre-dialog.action';

import { UpdateItems, updateItemsResult } from './update-items.action';

export const updateItemsEpic = (
    action: Observable<PayloadAction<ActionType, UpdateItems>>,
    _: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.NOTI__EC__UPDATE_ITEMS),
        switchMap((act: PayloadAction<ActionType, UpdateItems>) => {
            const service = deps.injector.get<ApiService>(ApiService);

            const obses = [];
            act.payload.items.forEach((e) => {
                const next = {
                    ...e,
                };
                let push = false;
                if (
                    act.payload.patch.read != null &&
                    e.read !== act.payload.patch.read
                ) {
                    next.read = act.payload.patch.read;
                    push = true;
                }
                if (
                    act.payload.patch.delete != null &&
                    e.deleted !== act.payload.patch.delete
                ) {
                    next.deleted = act.payload.patch.delete;
                    push = true;
                }
                if (push) {
                    obses.push(service.updateItem(next));
                }
            });

            return forkJoin(obses).pipe(
                map(() => {
                    return updateItemsResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
